<page-headline
    [linkTitle]="'Performance Home'"
    [module]="'performance'"
    [moduleIcon]="'fa-heartbeat'"
    [moduleLink]="'performance'"
    [pageTitle]="'Performance Insights'"
>
</page-headline>

<app-insights-directory-cards
    [applicationPage]="'performance/insights'"
></app-insights-directory-cards>
